import * as React from "react"
import type { IconProps } from "../types"

const Pin = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={color}
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fillRule="evenodd"
          d="M12.5914 21.8064L12.5926 21.8055L12.5944 21.8042L12.6 21.8001L12.6185 21.7863C12.6341 21.7746 12.6562 21.758 12.6844 21.7365C12.7406 21.6937 12.8211 21.6316 12.9223 21.5514C13.1245 21.3909 13.4102 21.1574 13.7514 20.8594C14.4326 20.2647 15.3426 19.407 16.2553 18.3551C18.0477 16.2895 20 13.3052 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 13.3052 5.95225 16.2895 7.74471 18.3551C8.65744 19.407 9.5674 20.2647 10.2486 20.8594C10.5898 21.1574 10.8755 21.3909 11.0777 21.5514C11.1789 21.6316 11.2594 21.6937 11.3156 21.7365C11.3438 21.758 11.3659 21.7746 11.3815 21.7863L11.4 21.8001L11.4056 21.8042L11.4081 21.806C11.7601 22.0642 12.2394 22.0645 12.5914 21.8064ZM11.9978 12.5C13.3785 12.5 14.4978 11.3807 14.4978 10C14.4978 8.61929 13.3785 7.5 11.9978 7.5C10.6171 7.5 9.4978 8.61929 9.4978 10C9.4978 11.3807 10.6171 12.5 11.9978 12.5Z"
        />
      </svg>
    )
  }
)
Pin.displayName = "Pin"

export default Pin
